/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IVideoPlayer contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum layout {
    column = 'column',
    row = 'row'
}

export const enum mobileVideoQuality {
    hdx = 'hdx',
    hq = 'hq',
    sd = 'sd',
    lo = 'lo'
}

export interface IVideoPlayerConfig extends Msdyn365.IModuleConfig {
    video: Msdyn365.IVideoData;
    heading?: IHeadingData;
    paragraph?: Msdyn365.RichText;
    links?: ILinksData[];
    additionalContent?: IAdditionalContentData;
    autoplay?: boolean;
    mute?: boolean;
    loop?: boolean;
    autoCaptions?: string;
    playPauseTrigger?: boolean;
    controls?: boolean;
    playFullScreen?: boolean;
    hidePosterFrame?: boolean;
    maskLevel?: number;
    thumbnailFullWidth?: boolean;
    lazyLoad?: boolean;
    clientRender?: boolean;
    layout: layout;
    cta?: ICtaData;
    mobileVideoQuality?: mobileVideoQuality;
    shouldDisableAutoPlayOnMobile?: boolean;
}

export interface IVideoPlayerResources {
    playLabel: string;
    pauseLabel: string;
    pausedLabel: string;
    playingLabel: string;
    unMuteLabel: string;
    muteLabel: string;
    fullScreenLabel: string;
    exitFullScreenLabel: string;
    seekBarLabel: string;
    videoTimeDurationLabel: string;
    closedCaptionLabel: string;
    optionButtonLabel: string;
    sliderThumbLabel: string;
    volumeThumbLabel: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IAdditionalContentData {
    heading?: string;
    subtext?: string;
    links?: ILinksData[];
}

export interface ICtaData {
    label?: string;
    link?: string;
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IVideoPlayerProps<T> extends Msdyn365.IModule<T> {
    resources: IVideoPlayerResources;
    config: IVideoPlayerConfig;
}
